'use strict';

export const defaultLogo = '/assets/images/default-logo.png';
export const defaultColor = '#222222';
export const defaultName = 'UEFA';

